import React from 'react';
import { graphql } from 'react-relay';
import Route from 'found/lib/Route';
import EventListContainer from '../components/Event/List/EventListContainer';
import EventIndexContainer from '../components/Event/List/EventIndexContainer';
import PipelinesContainer from '../components/Event/Pipelines/PipelinesContainer';
import EventCalendarContainer from '../components/Event/List/EventCalendarContainer';
import EventListQuery from './EventListQuery';
import EventCalendarQuery from './EventCalendarQuery';
import EventListParams from './params/EventListParams';
import EventCalendarParams from './params/EventCalendarParams';
import { Loader } from '../components/Elements';
import ViewerQuery from './ViewerQuery';

const EventListRoute = (
  <Route>
    <Route
      Component={EventIndexContainer}
      query={ViewerQuery}
      render={({ props }) => (props ? <EventIndexContainer {...props} /> : <Loader />)}
    >
      <Route
        Component={EventListContainer}
        prepareVariables={EventListParams}
        query={EventListQuery}
        render={({ props }) => (props ? <EventListContainer {...props} /> : <Loader />)}
      />
      <Route
        path='calendar'
        Component={EventCalendarContainer}
        prepareVariables={EventCalendarParams}
        query={EventCalendarQuery}
        render={({ props }) => (props ? <EventCalendarContainer {...props} /> : <Loader />)}
      />
    </Route>
    <Route
      path='pipelines'
      Component={PipelinesContainer}
      query={graphql`
        query EventListRoute_Pipelines_Query {
          viewer {
            ...PipelinesContainer_viewer
          }
        }
      `}
      render={({ props }) => (props ? <PipelinesContainer {...props} /> : <Loader />)}
    />
  </Route>
);

export default EventListRoute;



// WEBPACK FOOTER //
// ./webpack/routes/_EventListRoute.js